import ArquivoRetornoService from '../../../services/ArquivoRetornoService'
import {ILaudoAuditoria} from '../interfaces/ILaudoAuditoria'
import {LaudoAuditoriaService} from '../services/LaudoAuditoriaService'

// DEVN3-521 — dispara o export do laudo, acompanha a geração do arquivo e baixa quando fica
// pronto. Usado por /auditoria e /auditoria/revisao. Devolve a mensagem de erro, se houver.
export async function exportarLaudoEBaixar(
  periodo: string,
  formato: 'PDF' | 'DOCX',
  onAtualizar: (laudo: ILaudoAuditoria | null) => void
): Promise<string | undefined> {
  try {
    const {arquivoRetornoId} = await LaudoAuditoriaService.exportar(periodo, formato)
    const ext = formato === 'DOCX' ? 'docx' : 'pdf'
    for (let i = 0; i < 90; i++) {
      await new Promise((r) => setTimeout(r, 8000))
      const atual = await LaudoAuditoriaService.buscar(periodo)
      onAtualizar(atual)
      if (atual?.status === 'ERRO') return 'Falha ao gerar o laudo. Tente novamente.'
      if (atual?.arquivoRetornoPronto) {
        const url = await ArquivoRetornoService.obterUrlDownload(
          atual.arquivoRetornoId ?? arquivoRetornoId
        )
        const link = document.createElement('a')
        link.href = url
        link.download = `laudo_auditoria_${periodo}.${ext}`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return undefined
      }
    }
    return 'A geração do laudo demorou mais que o esperado. Tente novamente em alguns minutos.'
  } catch (e: any) {
    return e?.response?.data?.mensagem ?? 'Não foi possível exportar o laudo.'
  }
}
